import { Component, Input } from '@angular/core';

import { AuthService, Course, User } from '@app/core';

@Component({
  selector: 'app-course-card',
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.scss'],
  standalone: false,
})
export class CourseCardComponent {
  @Input() course: Course;
  @Input() class!: string;
  loggedinUser: User;

  constructor(private authService: AuthService) {
    this.loggedinUser = this.authService.user;
  }
}
